'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _apiBaseResponse = require('./services/apiBaseResponse');

var _apiBaseResponse2 = _interopRequireDefault(_apiBaseResponse);

var _apiCampaigns = require('./services/apiCampaigns');

var _apiCampaigns2 = _interopRequireDefault(_apiCampaigns);

var _apiContacts = require('./services/apiContacts');

var _apiContacts2 = _interopRequireDefault(_apiContacts);

var _apiDashboard = require('./services/apiDashboard');

var _apiDashboard2 = _interopRequireDefault(_apiDashboard);

var _apiEmail = require('./services/apiEmail');

var _apiEmail2 = _interopRequireDefault(_apiEmail);

var _apiImprint = require('./services/apiImprint');

var _apiImprint2 = _interopRequireDefault(_apiImprint);

var _apiInvestors = require('./services/apiInvestors');

var _apiInvestors2 = _interopRequireDefault(_apiInvestors);

var _apiNotifications = require('./services/apiNotifications');

var _apiNotifications2 = _interopRequireDefault(_apiNotifications);

var _apiPicklist = require('./services/apiPicklist');

var _apiPicklist2 = _interopRequireDefault(_apiPicklist);

var _apiSelections = require('./services/apiSelections');

var _apiSelections2 = _interopRequireDefault(_apiSelections);

var _apiTasks = require('./services/apiTasks');

var _apiTasks2 = _interopRequireDefault(_apiTasks);

var _apiTeam = require('./services/apiTeam');

var _apiTeam2 = _interopRequireDefault(_apiTeam);

var _apiUser = require('./services/apiUser');

var _apiUser2 = _interopRequireDefault(_apiUser);

var _digiCert = require('./services/digiCert');

var _digiCert2 = _interopRequireDefault(_digiCert);

var _filterHistory = require('./services/filterHistory');

var _filterHistory2 = _interopRequireDefault(_filterHistory);

var _genericMethods = require('./services/genericMethods');

var _genericMethods2 = _interopRequireDefault(_genericMethods);

var _messageBox = require('./services/messageBox');

var _messageBox2 = _interopRequireDefault(_messageBox);

var _apiAuthentication = require('./services/apiAuthentication');

var _apiAuthentication2 = _interopRequireDefault(_apiAuthentication);

var _taskMutationTrackingService = require('./services/taskMutationTrackingService');

var _taskMutationTrackingService2 = _interopRequireDefault(_taskMutationTrackingService);

var _apiGroups = require('./services/apiGroups');

var _apiGroups2 = _interopRequireDefault(_apiGroups);

var _apiRfps = require('./services/apiRfps');

var _apiRfps2 = _interopRequireDefault(_apiRfps);

var _campaignFilterHistory = require('./services/campaignFilterHistory');

var _campaignFilterHistory2 = _interopRequireDefault(_campaignFilterHistory);

var _sentEmailPopup = require('./services/sentEmailPopup');

var _sentEmailPopup2 = _interopRequireDefault(_sentEmailPopup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('advinda.services', []).service('ApiBaseResponseService', _apiBaseResponse2.default).service('ApiCampaigns', _apiCampaigns2.default).service('ApiContacts', _apiContacts2.default).service('ApiDashboard', _apiDashboard2.default).service('ApiEmail', _apiEmail2.default).service('ApiImprint', _apiImprint2.default).service('ApiInvestors', _apiInvestors2.default).service('ApiNotifications', _apiNotifications2.default).service('ApiPicklist', _apiPicklist2.default).service('ApiSelections', _apiSelections2.default).service('ApiTasks', _apiTasks2.default).service('ApiTeam', _apiTeam2.default).service('ApiUser', _apiUser2.default).service('digiCert', _digiCert2.default).service('filterHistory', _filterHistory2.default).service('GenericMethods', _genericMethods2.default).service('MessageBox', _messageBox2.default).service('ApiAuthentication', _apiAuthentication2.default).service('TaskMutationTrackingService', _taskMutationTrackingService2.default).service('ApiGroups', _apiGroups2.default).service('ApiRfps', _apiRfps2.default).service('campaignFilterHistory', _campaignFilterHistory2.default).service('sentEmailPopup', _sentEmailPopup2.default);


/** WEBPACK FOOTER **
 ** ./src/app/app.services.js
 **/